(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Open Anufit quiz modal from Static Tile 1 when static_tile_link_1 is empty
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-collection-open-anufit-quiz]');
    if (!trigger) return;

    const quizEl = document.getElementById('anufit-quiz');
    if (quizEl && typeof quizEl.openQuiz === 'function') {
      event.preventDefault();
      quizEl.openQuiz();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
